import { apiRequest } from "./apiRequest";

// ============================================================
// Organization
// ============================================================
export const serviceGetOrganizationDetails = async () => {
    const data = await apiRequest({
        path: `/organization/details`,
        method: "GET"
    });

    //todo ujj returns String not json object
    // return data;
    return typeof data === "string" ? JSON.parse(data) : data;
}

export const serviceRegisterOrganization = async (payload) => {
    return apiRequest({
        path: "/organization/register",
        method: "POST",
        body: payload
    });
}

// ============================================================
// Admin
// ============================================================
export const servicePostLoginAdmin = async (payload) => {
    return apiRequest({
        path: "/admin/login",
        authenticated: false,
        method: "POST",
        body: payload
    });
}

export const serviceRegisterAdmin = async (payload) => {
    return apiRequest({
        path: "/admin/register",
        method: "POST",
        body: payload
    });
}

export const serviceFetchAdminDetails = async () => {
    return apiRequest({
        path: "/admin/details",
        method: "GET",
    });
}

export const serviceAdminUsage = async () => {
    return apiRequest({
        path: `/admin/usage`,
        method: "PUT"
    });
}

export const serviceUpdateAdminDetails = async (payload) => {
    return apiRequest({
        path: "/admin/update",
        method: "PUT",
        body: payload
    });
}

export const serviceUpdateAdminPassword = async (payload) => {
    return apiRequest({
        path: "/admin/credentials",
        method: "PATCH",
        body: payload
    });
}

// ============================================================
// vehicle
// ============================================================
export const serviceVehicleGetList = async () => {
    const dataArray = await apiRequest({
        path: `/vehicles/meta`,
        method: "GET"
    });
    
    if (import.meta.env.DEV) {
        console.log("serviceVehicleGetList: ujj vehicles for org: ", dataArray);
    }

    return Array.isArray(dataArray) ? dataArray : [];
}

export const serviceVehicleGetDetails = async (vehicleId) => {
    if (!vehicleId) throw new Error("Invalid access");

    const data = apiRequest({
        path: `/vehicles/meta/${vehicleId}`,
        method: "GET"
    });

    return data;
}

export const serviceRegisterVehicle = async (payload) => {
    if (!payload?.vehicleCode) {
        throw new Error("Invalid vehicle");
    }

    return apiRequest({
        path: "/vehicles/register",
        method: "POST",
        body: payload
    });
}

export const serviceVehiclePutUpdate = async (vehicleId, payload) => {
    if (!vehicleId) throw new Error("Invalid vehicle");

    return apiRequest({
        path: `/vehicles/update/${vehicleId}`,
        method: "PUT",
        body: payload
    });
}

export const serviceVehicleDeleteVehicle = async (vehicleId) => {
    if (!vehicleId) throw new Error("Invalid vehicle");

    await apiRequest({
        path: `/vehicles/remove/${vehicleId}`,
        method: "DELETE"
    });

    return true;
}

export async function serviceCheckTrial() {
    const response = await apiRequest({
        path: `/vehicles/check/trial`,
        method: "PUT"
    });

    return response;
}

// ============================================================
// handles employees
// ============================================================
export const serviceEmployeeGetList = async () => {
    
    const data = await apiRequest({
        path: `/employees/meta`,
        method: "GET"
    });

    return Array.isArray(data) ? data : [];
}

export const serviceEmployeePostAdd = async (payload) => {

    return apiRequest({
        path: "/employees/register",
        method: "POST",
        body: payload
    });
}

export const serviceEmployeePutUpdate = async (employeeId, payload) => {
    if (!employeeId) throw new Error("Invalid employee");

    return apiRequest({
        path: `/employees/update/${employeeId}`,
        method: "PUT",
        body: payload
    });
}

export const serviceEmployeeDeleteEmployee = async (employeeId) => {
    if (!employeeId) throw new Error("Invalid employee");

    await apiRequest({
        path: `/employees/remove/${employeeId}`,
        method: "DELETE",
    });

    return true;
}

// ============================================================
// fleet location
// ============================================================
// ----- handles FleetLatest
export const serviceFleetLatestGetLatest = async () => {
    const dataArray = await apiRequest({
        path: `/fleet/latest`,
        method: "GET"
    });

    if (import.meta.env.DEV) {
        console.log("serviceFleetLatestGetLatest: ujj fleet latest locations: ", dataArray);
    }

    return Array.isArray(dataArray) ? dataArray : [];
}

export const serviceFleetLatestUpdateStatusOffline = async ({
    vehicleId
}) => {
    if (import.meta.env.DEV) {
        console.log("service: ujj fleet offline set: ", vehicleId);
    }

    if (!vehicleId) throw new Error("Invalid access");

    await apiRequest({
        path: `/fleet/offline/${vehicleId}`,
        method: "PUT",
    });
}
// ----- handles FleetTable
export const serviceFleetGetFleetLogs = async ({
    vehicleId,
    startIso,
    endIso
}) => {
    if (!vehicleId) throw new Error("Invalid access");

    //startIso and endIso are validated prior

    const data = await apiRequest({
        path: `/fleettable/${vehicleId}`,
        method: "GET",
        query: {
            startDate: startIso,
            endDate: endIso
        }
    });

    const arr = Array.isArray(data) ? data : [];

    // stable ordering by timestamp if present
    arr.sort(
        (a, b) => Number(a?.timestamp ?? 0) - Number(b?.timestamp ?? 0),
    );

    return arr;
}

// ----- handles FleetHistory

export const serviceFleetGetFleetHistory = async ({
    vehicleId,
    startIso,
    endIso
}) => {
    if (!vehicleId) throw new Error("Invalid access");

    //startIso and endIso are validated prior

    const data = await apiRequest({
        path: `/history/locations/${vehicleId}`,
        method: "GET",
        query: {
            startDate: startIso,
            endDate: endIso
        }
    });

    const array = Array.isArray(data) ? data : [];

    const sortDescending = array
        .slice()
        .sort((a, b) => {
            const ta = new Date(a?.timestamp).getTime();
            const tb = new Date(b?.timestamp).getTime();
            return tb - ta; //latest first
        });

    return sortDescending;
}

// for fleetMessageprompt send call
export const serviceMessageSend = async (organizationId, vehicleId, payload) => {
    if (!organizationId) throw new Error("Invalid user");
    if (!vehicleId) throw new Error("Invalid vehicle");

    return apiRequest({
        path: `/messages`,
        method: "POST",
        body: payload
    });
}

// ── GET /messages/all?organizationId=... ─────────────────────────────────────
// Admin gets all messages for an organization.
// Optional filters: vehicleId, messageStatus, messageType, limit, skip.
export const serviceMessageGetAll = async (organizationId, filters = {}) => {
    if (!organizationId) throw new Error("Invalid user");

    return apiRequest({
        path: `/messages/all`,
        method: "GET",
        query: {
            organizationId: organizationId,
            vehicleId: filters.vehicleId,
            messageStatus: filters.messageStatus,
            MessageType: filters.messageType,
            limit: filters.limit ?? 100,
            skip: filters.skip ?? 0,
        }
    });
}

// ── GET /messages/vehicle?organizationId=...&vehicleId=... ───────────────────
// Admin gets messages for one vehicle.
export const serviceMessageGetVehicle = async (
    organizationId,
    vehicleId,
    options = {}
) => {
    if (!organizationId) throw new Error("Invalid user");
    if (!vehicleId) throw new Error("Invalid vehicle");

    return apiRequest({
        path: "/messages/vehicle",
        method: "GET",
        query: {
            organizationId: organizationId,
            vehicleId: vehicleId,
            limit: options.limit ?? 100,
            skip: options.skip ?? 0,
        },
    });
};

// ── GET /messages/code?organizationId=...&messageCode=... ────────────────────
// Admin gets one message by messageCode.
export const serviceMessageGetByCode = async (organizationId, messageCode) => {
    if (!organizationId) throw new Error("Invalid user");
    if (!messageCode) throw new Error("Invalid message code");

    return apiRequest({
        path: "/messages/code",
        method: "GET",
        query: {
            organizationId: organizationId,
            messageCode: messageCode,
        },
    });
};